var swiperMain;
Revolution.Module.extend({
    NAME: "mde.swiper-main", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        // _.bindAll(this, "closeNavMob", "showBtnExpendTouch");
        //

        if ($('.swiper-main').length) {

            $('.swiper-main').each(function (index, elem) {
                var nbrSlidesPerView = $(elem).hasClass("swiper-2-columns") ? 2 : 1;
                var spaceBetween = $(elem).hasClass("swiper-2-columns") ? 40 : 10;
                // var autoplay = $(elem).hasClass("swiper-2-columns") ? false : {delay: 7000};
                var autoplay;


                var swiperMain = new Swiper(elem, {
                    slidesPerView: nbrSlidesPerView,
                    spaceBetween: spaceBetween,
                    fadeEffect: {
                        crossFade: true
                    },

                    speed: 1500,

                    autoplay: true,
                    watchSlidesProgress: true,
                    watchVisibility: true,

                    pagination: {
                        el: $(elem).find('.swiper-pagination'),
                    },

                    navigation: {
                        nextEl: $(elem).find('.swiper-button-next'),
                        prevEl: $(elem).find('.swiper-button-prev'),
                    },

                    on: {
                        slideChangeTransitionStart: function () {
                            var imgs = this.$wrapperEl.find('.lazy:not(b-loaded)');
                            window.bLazy.load(imgs);
                        },

                    }
                });
                
                $(this).mouseenter(function() {
                    swiperMain.autoplay.start();
                    // console.log('slider started');
                });
                
                $(this).mouseleave(function() {
                    swiperMain.autoplay.stop();
                    // console.log('slider stopped');
                });

            });
        }

        if ($('.swiper-services').length) {

            $('.swiper-services').each(function (index, elem) {
                var autoplay = $(elem).hasClass("swiper-2-columns") ? false : {delay: 7000};
                var autoplay;


                var swiperMain = new Swiper(elem, {
                    loop: true,
                    fadeEffect: {
                        crossFade: true
                    },

                    speed: 1500,

                    autoplay: autoplay,
                    watchSlidesProgress: true,
                    watchVisibility: true,
                    slidesPerView:1,
                    spaceBetween: 5,

                    breakpoints: {
                        // when window width is >= 900px
                        900: {
                          slidesPerView: 4,
                          spaceBetween: 5
                        }
                    },

                    // If we need pagination
                    pagination: {
                        el: $(elem).find('.swiper-pagination'),
                        clickable: true,
                    },

                    // Navigation arrows
                    navigation: {
                        nextEl: $('.bk-services .swiper-button-next'),
                        prevEl: $('.bk-services .swiper-button-prev'),
                    },

                    on: {
                        slideChangeTransitionStart: function () {
                            var imgs = this.$wrapperEl.find('.lazy:not(b-loaded)');
                            window.bLazy.load(imgs);
                        },

                    }
                });
                
                $(this).mouseenter(function() {
                    swiperMain.autoplay.start();
                });
                
                $(this).mouseleave(function() {
                    swiperMain.autoplay.stop();
                });

            });
        }
    },

    onWindowLoad: function (e) {
        if ($('.page-biens-exclusifs .bk-head-title').length) {
          var banHeight = $('.page-biens-exclusifs .bk-head-title').outerHeight() + 20;
          $('.page-biens-exclusifs .bk-return-link.-absolute').css('bottom' , banHeight);
        }
    },

    onWindowScroll: function (e) {
    },
    onWindowResize: function (e) {
    }
});

$(document).ready(function(){
  });
